import localforage from "localforage";
import "localforage-getitems";
import { extendPrototype } from "localforage-setitems";

extendPrototype(localforage);

const INDEXED_DB_NAME = "Fylm.ai Lite";
const INDEXED_DB_DESCRIPTION = "Fylm.ai Lite - Web's most advanced colour corrector";
const INDEXED_DB_VERSION = 1.0;
export const INDEXED_DB_VERSION_LUT_CONTROLS = 1.1;
export const INDEXED_DB_VERSION_LUT_SLIDERS = 1.1;
export const INDEXED_DB_VERSION_SYSTEM_LUTS = 1.3;

// Removing old DB
// localforage.dropInstance({
// 	name: 'Lutify'
// });

localforage.config({
	name: INDEXED_DB_NAME,
	description: INDEXED_DB_DESCRIPTION,
	version: INDEXED_DB_VERSION
});

class IDBService {
	constructor(storeName) {
		this.storeName = storeName
	}

	createInstance() {
		return localforage.createInstance({
			name: INDEXED_DB_NAME,
			storeName: this.storeName,
			description: INDEXED_DB_DESCRIPTION,
		})
	}

	clear() {
		return this.createInstance().clear();
	}

	removeItem(key) {
		return this.createInstance().removeItem(String(key));
	}

	getItem(key) {
		return this.createInstance().getItem(String(key));
	}

	async getItems(keys) {
		if (keys) {
			let result = await this.createInstance().getItems(keys);
			return Object.fromEntries(Object.entries(result).filter(([_, v]) => v != null));
		}

		else return await this.createInstance().getItems();
	}

	setItem(key, data) {
		return this.createInstance().setItem(String(key), data);
	}

	setItems(data) {
		return this.createInstance().setItems(data);
	}
}

export const versionStore = new IDBService('Version');
export const LUTcontrolsStore = new IDBService('LUTcontrols');
export const LUTslidersStore = new IDBService('LUTsliders');
export const systemLutsStore = new IDBService('SystemLuts');
export const imagesStore = new IDBService('Images');
export const uploadImagesStore = new IDBService('Upload Images');
export const thumbnailsStore = new IDBService('Thumbnails');
export const matchesStore = new IDBService('Matches');
export const candidatesStore = new IDBService('Candidates');
export const uploadCandidatesStore = new IDBService('Upload candidates');
export const uploadMatchesStore = new IDBService('Upload matches');
export const imagesStateStore = new IDBService('Images state');
export const layoutsStore = new IDBService('Layouts');
export const customLutsStore = new IDBService('Custom Luts');
export const presetsStore = new IDBService('Presets');
export const blocksStore = new IDBService('Blocks');
export const projectsThumbnailsStore = new IDBService('Projects thumbnails');
export const defaultsStore = new IDBService('Defaults');
